// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"7eb05adb","77":"98155ec1","208":"a63425a0","372":"9ce7f77f","386":"062923a6","553":"057fb469","788":"279a0f8b","789":"566cc354","882":"1ef94fb0"}[chunkId] + ".chunk.js";
};